// extracted by mini-css-extract-plugin
module.exports = {"container":"container-module_container","header":"container-module_header","main":"container-module_main","scroll":"container-module_scroll","panel":"container-module_panel"};